import { Container } from 'bitmovin-player-ui';
import { createPlayNextButton, createCancelPlayNextButton } from './buttons';
export function createPlayNextScreen(player, npoplayer) {
    const playNextButton = createPlayNextButton(player, npoplayer);
    const cancelButton = createCancelPlayNextButton(player, npoplayer);
    return new Container({
        components: [cancelButton, playNextButton],
        cssClasses: ['overlay-playnext']
    });
}
